export default {"src":"/_next/static/media/accuracy_80.ae004261.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};